import logger from './loggerService';

const MIGRATION_VERSION_KEY = 'sp:migration:theme_v2';
const LEGACY_THEME_STORE_KEY = 'sp:theme:store';

export class ThemeMigrationService {
  /**
   * One-time migration from global sp:theme:store to user-scoped sp:theme:mode:{userId}.
   * Runs exactly once per browser via version gate. Extracts legacy preference and caches
   * it in sessionStorage.
   * 
   * @security This runs BEFORE auth — it touches only theme state (no PII, no tokens).
   */
  static executeMigration(): void {
    try {
      if (typeof window === 'undefined') return;

      // Version gate: skip if already migrated
      if (localStorage.getItem(MIGRATION_VERSION_KEY) === '1') return;

      const legacyRaw = localStorage.getItem(LEGACY_THEME_STORE_KEY);
      if (legacyRaw) {
        const parsed = JSON.parse(legacyRaw);
        const legacyMode = parsed?.state?.theme; // Zustand persist format
        if (legacyMode === 'light' || legacyMode === 'dark') {
          // Cache the extracted preference for initTheme to consume
          sessionStorage.setItem('sp:theme:legacy_migration', legacyMode);
          logger.info(`Migrating legacy theme preference "${legacyMode}" to temporary cache`, { context: 'ThemeMigrationService' });
        }
        // Remove the stale key
        localStorage.removeItem(LEGACY_THEME_STORE_KEY);
      }

      // Mark migration as complete
      localStorage.setItem(MIGRATION_VERSION_KEY, '1');
    } catch (error) {
      logger.error('Failed to execute legacy theme migration', error, 'ThemeMigrationService');
    }
  }
}
